import React, { Component } from 'react'
import { glasConfig } from '../constants/Config'
import request from 'axios'
import StaffBlogList from './StaffBlogList'
import StaffBlogPager from './StaffBlogPager'
import $ from 'jquery'
import { StyledContainerHomeBlogList } from './Home/Styled/StyledHomeComponents'

export default class StaffBlog extends Component {
	constructor(props) {
		super(props)
		this.state = {
			total: 0,
			totalpages: 0,
			keyword: '',
			page: 1,
			category: '',
			data: [],
		}
	}
	
	componentWillMount() {
		const { category, page, size, keyword } = this.props
		this.getData({
			search: keyword,
			category: category,
			size: size,
			page: page,
		})
	}

	componentDidMount() {
		$('.secondary-header').addClass('hiddenClass')
		$('.header-back').removeClass('hiddenClass')
		$('.component-title').text('運営ブログ')
	}
	componentWillUnmount() {
		$('.secondary-header').removeClass('hiddenClass')
		$('.header-back').addClass('hiddenClass')
		$('.component-title').text('')
	}

	componentWillReceiveProps(nextProps) {
		const { category, page, size, keyword } = nextProps
		this.getData({
			search: keyword,
			category: category,
			size: size,
			page: page,
		})
	}

	/**
	 * 記事詳細を取得
	 */
	getData(res) {
		
		let params = {};
		
		if (res.category !== undefined && res.category) {
			params.categories = res.category
		}
		if (res.search !== undefined && res.search) {
			params.search = res.search
			params.page = (res.search !== this.state.keyword) ? 1 : res.page
		} else {
			params.page = res.page
		}
		
		params.size = (res.size !== undefined && res.size !== null) ? res.size : 10;

		const url = glasConfig.url_base + glasConfig.get_lst_blog
		const options = {
			method: 'GET',
			url: url,
			params,
			headers: {
				Authorization: localStorage.getItem('token'),
				'Cache-Control': 'no-cache',
    			'Pragma': 'no-cache'
			},
			json: true,
		}

		request(options)
			.then((response) => {
				this.setState({
					total: Math.ceil(response.data.data.total / params.size),
					totalpages: Math.ceil(response.data.data.total / params.size),
					page: params.page,
					keyword: res.search || '',
					category:
						params.categories === undefined
							? ''
							: params.categories,
					data: Array.isArray(response.data.data.list) 
					? response.data.data.list 
					: [],
				})
			})
			.catch((error) => {
				this.setState({
					data: [],
				  })
			})
	}

	render() {
		const { exclude, pager } = this.props
		if (this.state.data.length) {
			return (
				<div>
					<StyledContainerHomeBlogList>
						<StaffBlogList
							data={this.state.data}
							exclude={exclude}
						/>
					</StyledContainerHomeBlogList>
					<StaffBlogPager
						pager={pager}
						page={this.state.page}
						totalpages={this.state.totalpages}
						category={this.state.category}
					/>
				</div>
			)
		}
		return null
	}
}
